module.exports = __webpack_public_path__ + "assets/images_base/country.svg?v=757d5f42";